export const colors = {
  primary: "#00537D",
  primaryHover: "#063F5E",
  main: "#5f4f3d",
  blue: "#009ADC",
  lightBlue: "#0076B3",
  disable: "#dddddd",
  secondary: "#ec610d",
  green: "#008000",
  yellow: "#ffcc00",
  yellowHover: "#e2b502",
  greyDark: "#4b4b4b",
  black: "#000",
  blackVariant: "#231f20",
  lightGrey: "#c7c7c7",
  lightGreyVariant: "#f2f4f8",
  grey: "#c4c4c4",
  darkGrey: "#464646",
  red: "#D92736",
  darkRed: "#B9222E",
  orange: "#f87131",
  white: "#ffffff",
  boxShadow: "#00000029",
  border: "#dddddd",
  heading: "#535353",
  blueLink: "#002791",
  blueVarant: "#193C9C",
  transparantBg: "rgba(0, 0, 0, .3)",
  rowColor: "#eaebee",
  success: "#299D49",
  successVariant: "#DDFFE6",
  warning: "#CE443B",
  warningVariant: "#FFCAC6",
};

export const fontSizes = {
  font12: "0.75rem", //12px
  font14: "0.875rem", //14px
  font16: "1rem", //16px
  font17: "1.063rem", //17px
  font18: "1.125rem", //18px
  font20: "1.25rem", //20px
  font24: "1.5rem", //24px
  font26: "1.529rem", //26px
  font28: "1.75rem", //28px
  font30: "1.875rem", //30px
  font36: "2.25rem", //36px
  font42: "2.625rem", //42px
  font48: "3rem", //48px
  font60: "3.75rem", //60px
  font64: "4rem", //60px
  font80: "5rem", //80px
  font90: "5.625rem", //90px
};

export const fontFamilies = {
  signPainter: `"SignPainter-HouseScript", sans-serif`,
  frontage: `"FrontageCondensed-Inline", sans-serif`,
  poppins: `'Poppins', sans-serif`,
  lato: `'Lato', sans-serif`,
};

export const breakpoints = {
  mobileMaxWidth: "991px",
  // container: "1280px",
  container: "1920px",
  containerStandard: "1366px",
  belowiPad: "768px",
  mobileMinWidth: "360px",
  sliderMobileBreakpoint: "550px",
};

export const mediaQueries = {
  mobileAndAbove: `(min-width: ${breakpoints.mobileMaxWidth})`,
  containerAndAbove: `(min-width: ${breakpoints.container})`,
  belowiPad: `(max-width: ${breakpoints.belowiPad})`,
  aboveiPad: `(min-width: ${breakpoints.belowiPad})`,
  belowContainerStandard: `(max-width: ${breakpoints.containerStandard})`,
  aboveContainerStandard: `(min-width: ${breakpoints.containerStandard})`,
  belowContainer: `(max-width: ${breakpoints.container})`,
  mobileMinWidth: `(min-width: ${breakpoints.mobileMinWidth})`,
  mobileMaxWidth: `(max-width : ${breakpoints.mobileMaxWidth})`,
  sliderMobileBreakPoint: `(max-width : ${breakpoints.sliderMobileBreakpoint})`,
};

export const signInPics = {
  drinkImage: `./images/signInPic.png`,
};
export const bgSetting = {
  dottedPatternDesktop: `./background/Page_BG.png`,
  dottedPatternMobile: `./background/BG_mobile.png`,
  footerImage: `./background/Footer_BG.png`,
  dotImage: `./background/background_dots.png`,
  leftImage: `./background/background_left.png`,
  rightImage: `./background/background_right.png`,
};

export const cartPics = {
  deleteIcon: `./icons/delete-icon.png`,
  uploadImageIcon: `./icons/uploadImg-icon.png`,
  shoppingIcon: `./icons/Cart-icon.png`,
};

export const contactIcons = {
  writeIcon: "./icons/Write.png",
  callIcon: "./icons/Call.png",
};
